module.exports = __webpack_public_path__ + "static/media/rr.eb85b0c9.svg";